import { render, staticRenderFns } from "./addAiEventAlartDialog.vue?vue&type=template&id=2ead5b86&scoped=true"
import script from "./addAiEventAlartDialog.vue?vue&type=script&lang=js"
export * from "./addAiEventAlartDialog.vue?vue&type=script&lang=js"
import style0 from "./addAiEventAlartDialog.vue?vue&type=style&index=0&id=2ead5b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead5b86",
  null
  
)

export default component.exports